<template>
  <div class="box">
    <p class="tit_con">
      第十六届全国治疗药物监测学术年会
    </p>
    <div class="step_boxs">
      <div
        class="step1"
        v-for="(item, i) in tit"
        :key="i"
        :class="{ step1act: step >= i }"
      >
        <div class="step_box">
          <p class="num">{{ i + 1 }}</p>
          <p class="line" v-if="i < 3"></p>
        </div>
        <div class="step_tit">{{ item }}</div>
      </div>
    </div>
    <div v-show="step == 0">
      <Son @nextSpet="nextSpet" @data1="changDate1" />
    </div>
    <div v-show="step == 1">
      <Son1 @nextSpet="nextSpet" @data="changDate" />
    </div>
    <div v-show="step == 2">
      <Son2 @nextSpet="nextSpet" :bigForm="bigFor1" ref="son2" />
    </div>
    <div v-show="step == 3">
      <Son3 :id="id" />
    </div>

    <!-- <Son2 /> -->
  </div>
</template>

<script>
import Son from './commpents/son1'
import Son1 from './commpents/son2'
import Son2 from './commpents/son3'
import Son3 from './commpents/son4'

export default {
  name: 'Home',
  components: {
    Son,
    Son1,
    Son2,
    Son3
  },
  data() {
    return {
      step: 0,
      tit: ['论文内容编辑', '论文作者编辑', '确认论文信息', '提交论文'],
      ruleForm: {
        type: []
      },
      rules: {
        name: [
          { require: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      bigFor1: 0,
      bigForm: {
      },
      id: '0'
    }
  },
  created() {


  },
  methods: {

    changDate(a) {
      this.bigForm.from1 = a
    },
    changDate1(a) {
      this.bigForm.from2 = a
    },
    nextSpet(val) {
      if (val == 2) {
        ++this.bigFor1 
      }
      if (val == 3) {
        this.id = this.$refs.son2.getid()
      }
      this.step = val
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.step1act {
  .num {
    background-color: #00599e !important;
  }
  .line {
    background-color: #00599e !important;
  }
  .step_tit {
    color: #00599e !important;
  }
}
.tit_con {
  text-align: center;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #00599e;
}
.step_boxs {
  display: flex;
  margin-left: 40px;
  margin: 50px 0;

  .step1 {
    margin-left: 5px;
    .step_box {
      display: flex;
      align-items: center;
      .num {
        width: 40px;
        height: 40px;
        background-color: #c9dcea;
        line-height: 40px;
        text-align: center;
        border-radius: 50%;
        font-size: 18px;
        color: #fff;
      }
      .line {
        width: 300px;
        height: 3px;
        background-color: #c9dcea;
      }
    }
    .step_tit {
      width: 108px;
      // border: 1px solid red;
      text-align: center;
      margin-top: 20px;
      margin-left: -36px;
      font-size: 18px;
      color: #a8c5da;
    }
  }
}
</style>
